export default {
  'pages.layouts.userLayout.title':
    'Efficiently synchronize production NOSQL and SQL data, supporting initial and incremental synchronization with index monitoring',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: admin',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.password.title': 'Change Admin Password',
  'pages.password.oldPassword': 'Current Password',
  'pages.password.newPassword': 'New Password',
  'pages.password.confirmPassword': 'Confirm Password',
  'pages.password.inputOldPassword': 'Please input current password',
  'pages.password.inputNewPassword': 'Please input new password',
  'pages.password.inputConfirmPassword': 'Please confirm new password',
  'pages.password.passwordMismatch': 'The two passwords do not match',
  'pages.password.passwordTooShort': 'Password must be at least 6 characters',
  'pages.password.success': 'Password changed successfully',
  'pages.password.failure': 'Failed to change password',
  'pages.password.current.error': 'Current password is incorrect',
  'pages.userManage.title': 'User Management',
  'pages.userManage.username': 'Username',
  'pages.userManage.email': 'Email',
  'pages.userManage.currentAccess': 'Current Role',
  'pages.userManage.newAccess': 'New Role',
  'pages.userManage.apply': 'Apply',
  'pages.userManage.cancel': 'Cancel',
  'pages.userManage.loadFailed': 'Failed to load user list',
  'pages.userManage.updateSuccess': 'User roles updated successfully',
  'pages.userManage.updateFailed': 'Failed to update user roles',
  'pages.userManage.status': 'Status',
  'pages.userManage.active': 'Active',
  'pages.userManage.inactive': 'Inactive',
  'pages.userManage.changeStatus': 'Change Status',
  'pages.userManage.actions': 'Actions',
  'pages.userManage.delete': 'Delete',
  'pages.userManage.deleteConfirm': 'Are you sure you want to delete this user?',
  'pages.userManage.yes': 'Yes',
  'pages.userManage.no': 'No',
  'pages.userManage.deleteSuccess': 'User deleted successfully',
  'pages.userManage.deleteFailed': 'Failed to delete user',

  'pages.googleCallback.processing': 'Processing Google login...',
  'pages.googleCallback.success': 'Login Successful',
  'pages.googleCallback.debug': 'Google Login Debug',
  'pages.googleCallback.enterHome': 'Enter Homepage',
  'pages.googleCallback.retry': 'Retry Authentication',
  'pages.googleCallback.returnLogin': 'Return to Login',
  'pages.googleCallback.initializing': 'Initializing...',
  'pages.googleCallback.processingCode': 'Processing Google authorization code...',
  'pages.googleCallback.apiTimeout': 'API request timeout!',
  'pages.googleCallback.noAuthCode': 'No authorization code found, please check URL format',
  'pages.googleCallback.tokenSaved': 'Access token saved, length: ',
  'pages.googleCallback.loginSuccess': 'Google login successful',
  'pages.googleCallback.userStateUpdated': 'User state updated, preparing to redirect...',
  'pages.googleCallback.manualProcessing': 'Manually processing authorization code...',
  'pages.googleCallback.noAuthCodeFound': 'No authorization code found in URL',
  'pages.googleCallback.componentLoaded': 'Component loaded, processing callback...',
  'pages.googleCallback.foundAuthCode': 'Found authorization code: ',
  'pages.googleCallback.loginFailed': 'Login processing failed',

  'pages.settings.auth.title': 'Authentication',
  'pages.settings.auth.enableOAuth': 'Enable {provider} Account Login',
  'pages.settings.auth.uploadConfig': 'OAuth client configuration file',
  'pages.settings.auth.configFileHint':
    'The client_secret JSON the Google Cloud console hands you when you create the credential.',
  'pages.settings.auth.selectFile': 'Select File',
  'pages.settings.auth.jsonFileOnly': 'You can only upload JSON files!',
  'pages.settings.auth.fileSizeLimit': 'File must be smaller than 2MB!',
  'pages.settings.auth.loading': 'Loading settings...',
  'pages.settings.auth.save': 'Save Settings',
  'pages.settings.auth.saveSuccess': 'Settings saved successfully',
  'pages.settings.auth.saveFailed': 'Failed to save settings',
  'pages.settings.auth.fetchFailed': 'Failed to fetch settings',
  'pages.settings.auth.configHelp.title': 'Configuration Help',
  'pages.settings.auth.configHelp.description':
    "Create an OAuth client ID in the Google Cloud console and upload its JSON file here. The redirect URI it carries has to match this deployment's callback.",
  'pages.settings.auth.configHelp.hint':
    'New OAuth settings will take effect after system restart.',
  'pages.settings.auth.currentConfig': 'Current Configuration',
  'pages.settings.auth.clientId': 'Client ID: {id}',
  'pages.settings.auth.redirectUri': 'Redirect URI: {uri}',
  'pages.settings.auth.scopes': 'Authorization Scopes: {scopes}',
  'pages.settings.auth.enableGoogleOAuth': 'Enable Google Account Login',
  'pages.settings.auth.fileContentError':
    'Unable to get file content, please select the file again',
  'pages.settings.auth.jsonParseError': 'Failed to parse JSON file, please verify the file format',
  'pages.settings.auth.fileReadError': 'Failed to read file',
  'pages.settings.auth.missingClientId': 'Configuration file is missing client_id field',
  'pages.settings.auth.missingClientSecret': 'Configuration file is missing client_secret field',
  'pages.settings.auth.missingRedirectUri': 'Configuration file is missing redirect_uri field',
  'pages.settings.auth.apiRequestFailed': 'API request failed: {message}',
  'pages.settings.auth.configProcessError':
    'Unknown error occurred while processing configuration file',
  'pages.settings.auth.updateSettingsFailed': 'Failed to update settings',

  'pages.login.oauthLogin': 'Login with {provider}',
  'pages.login.googleLogin': 'Login with Google',
  'pages.settings.auth.uploadGoogleConfig': 'Upload Google OAuth Configuration File',
  'pages.settings.auth.googleConfigFileHint':
    'Please upload the OAuth client JSON configuration file from Google Cloud Console',
  'pages.settings.auth.googleConfigHelp.description':
    'You need to create an OAuth client ID in Google Cloud Console and download the JSON configuration file. Make sure you have set the correct redirect URI for your application callback.',

  'pages.syncSettings.advancedSecurity': 'Advanced Security Options (Field Encryption/Masking)',
  'pages.syncSettings.table': 'Table: ',
  'pages.syncSettings.fieldName': 'Field Name',
  'pages.syncSettings.fieldType': 'Type',
  'pages.syncSettings.fieldStatus': 'Status',
  'pages.syncSettings.operation': 'Operation',
  'pages.syncSettings.status.normal': 'Normal',
  'pages.syncSettings.status.masked': 'Masked',
  'pages.syncSettings.status.encrypted': 'Encrypted',
  'pages.syncSettings.action.mask': 'Mask',
  'pages.syncSettings.action.encrypt': 'Encrypt',
  'pages.syncSettings.action.restore': 'Restore',
  'pages.syncSettings.message.fieldStatusChanged':
    'The status of field {field} in table {table} has been changed to {status}',
  'pages.syncSettings.fetchFieldsFailed': 'Failed to fetch table fields',
  'pages.syncSettings.loadingFields': 'Loading fields...',
  'pages.syncSettings.missingConnectionInfo':
    'Connection information is incomplete, unable to fetch table fields',

  'pages.sync.fieldName': 'Field Name',
  'pages.sync.fieldType': 'Field Type',
  'pages.sync.securityOptions': 'Security Options',
  'pages.sync.encrypt': 'Encrypt',
  'pages.sync.mask': 'Mask',
  'pages.sync.restore': 'Restore',
  'pages.sync.tableFieldInfo': 'Table Field Info',
  'pages.sync.advancedSecurity': 'Advanced Security Options',
  'pages.sync.enableAdvancedSecurity': 'Enable Advanced Security',
  'pages.sync.testConnection': 'Test Connection',
  'pages.sync.updateSucesss': 'Update successful',
  'pages.sync.addSucesss': 'Add successful',
  'pages.sync.updateFailed': 'Update failed',
  'pages.sync.addFailed': 'Add failed',
  'pages.sync.selectSourceType': 'Please select a Source Type',
  'pages.sync.completeSourceConn': 'Please complete the source connection information',
  'pages.sync.sourceConnSuccess': 'Source DB connection successful',
  'pages.sync.sourceConnFailed': 'Source DB connection failed',
  'pages.sync.completeTargetConn': 'Please complete the target connection information',
  'pages.sync.targetConnSuccess': 'Target DB connection successful',
  'pages.sync.targetConnFailed': 'Target DB connection failed',
  'pages.sync.testConnError': 'Error testing connection',
  'pages.sync.sourceConnAutoSuccess': 'Source DB connection successful (auto load)',
  'pages.sync.sourceConnAutoFailed': 'Source DB connection failed (auto load)',
  'pages.sync.targetConnAutoSuccess': 'Target DB connection successful (auto load)',
  'pages.sync.targetConnAutoFailed': 'Target DB connection failed (auto load)',
  'pages.sync.wholeDatabaseLabel': '同步整个数据库',
  'pages.sync.wholeDatabaseHelp':
    '不逐个勾选表。这个库现有的表全部复制，之后新建的表也会自动跟上——逐表勾选做不到最后这一点，业务加了一张表，它就永远不在副本里。',
  'pages.sync.availableTables': 'Available Tables',
  'pages.sync.selectedTables': 'Selected',
  'pages.sync.editConfig': 'Edit sync task',
  'pages.sync.addConfig': 'New sync task',
  'pages.sync.sourceType': 'Source Type',
  'pages.sync.sourceDBConn': 'Source DB Connection',
  'pages.sync.targetDBConn': 'Target DB Connection',
  'pages.sync.tableMapping': 'Table/Collection Mapping',
  'pages.sync.taskName': 'Task Name',
  'pages.sync.pleaseEnterTaskName': 'Please enter the task name',
  'pages.sync.pleaseSelectSourceType': 'Please select the source type',
  'pages.sync.host': 'Host',
  'pages.sync.port': 'Port',
  'pages.sync.username': 'Username',
  'pages.sync.password': 'Password',
  'pages.sync.databaseName': 'Database Name',
  'pages.sync.pleaseEnterSourceHost': 'Please enter the source DB host',
  'pages.sync.pleaseEnterSourcePort': 'Please enter the source DB port',
  'pages.sync.pleaseEnterSourceDB': 'Please enter the source DB name',
  'pages.sync.pleaseEnterTargetHost': 'Please enter the target DB host',
  'pages.sync.pleaseEnterTargetPort': 'Please enter the target DB port',
  'pages.sync.pleaseEnterTargetDB': 'Please enter the target DB name',
  'pages.sync.pleaseEnterSourceUsername': 'Please enter source username',
  'pages.sync.pleaseEnterSourcePassword': 'Please enter source password',
  'pages.sync.pleaseEnterTargetUsername': 'Please enter target username',
  'pages.sync.pleaseEnterTargetPassword': 'Please enter target password',
  'pages.sync.securityEnabled': 'Enabled',
  'pages.sync.securityDisabled': 'Disabled',

  // Backup related internationalization
  'pages.backup.form.fileNamePattern': '文件名模式（正则表达式）',
  'pages.backup.form.fileNamePattern.required': '请输入文件名模式',
  'pages.backup.form.fileNamePattern.placeholder': '例如：^{table}_\\d{4}-\\d{2}-\\d{2}_.*\\.json$',
  'pages.backup.form.fileNamePattern.invalid': '无效的正则表达式',
  'pages.backup.form.fileNamePattern.tooltip':
    '用于匹配备份文件名的正则表达式模式。鼠标悬停可查看匹配示例。',
  'pages.settings.replication.title': 'Replication settings',
  'pages.settings.replication.subTitle':
    'Stored in the control database and read when a task next starts. Zero means the built-in default.',
  'pages.settings.replication.verify': 'Consistency check',
  'pages.settings.replication.verifyNote':
    'A full comparison reads every replicated row twice, on the source and on the target.',
  'pages.settings.replication.verifyInterval': 'Interval',
  'pages.settings.replication.verifyRepair': 'Repair what it finds',
  'pages.settings.replication.verifyRepairNote':
    'A check that repairs is a second writer on the target.',
  'pages.settings.replication.monitoring': 'Monitoring',
  'pages.settings.replication.lagAlert': 'Lag alert',
  'pages.settings.replication.batches': 'Batches',
  'pages.settings.replication.batchEvents': 'Events per batch',
  'pages.settings.replication.batchBytes': 'Bytes per batch',
  'pages.settings.replication.batchBytesNote':
    'This is what bounds the memory a batch of large rows takes.',
  'pages.settings.replication.recovery': 'Recovery',
  'pages.settings.replication.recopy':
    'Copy the source again when the stored position cannot be used',
  'pages.settings.replication.recopyNote':
    'Redis keeps its replication history in memory, so a restart of the source ends the history every stored position belongs to and the task can no longer resume. On, the task rebuilds the target by copying the source and then removes whatever the source has deleted since. Off, it stops and waits for someone \u2014 which for a standby means standing still until somebody notices.',
  'pages.settings.replication.redisBuffer': 'Redis buffer per shard',
  'pages.settings.replication.redisBufferNote':
    'The replication stream is written to local disk so that a stopped task resumes from there instead of taking a full copy \u2014 the source keeps a megabyte, this keeps gigabytes. Left at zero, each shard gets a share of the volume it is written to; a fixed figure per shard can add up to more disk than exists.',
  'pages.settings.replication.queues': 'Queues and copies',
  'pages.settings.replication.queuesNote':
    'The byte bound is what decides how much memory a running task can take. The copy batch is the load a first copy puts on the source.',
  'pages.settings.replication.queueEvents': 'Events queued between reading and applying',
  'pages.settings.replication.queueBytes': 'Bytes queued between reading and applying',
  'pages.settings.replication.snapshotQueueEvents': 'Events queued by a first copy',
  'pages.settings.replication.flushInterval': 'How long a batch waits to fill',
  'pages.settings.replication.copyBatchRows': 'Rows per round trip of a first copy',
  'pages.settings.replication.streamAwait': 'Change stream await window',
  'pages.settings.replication.streamAwaitNote':
    'On a sharded source this is a floor under every change\u2019s latency: mongos answers when the window ends rather than when the event arrives. Shorter is less delay and one more poll per interval.',
  'pages.settings.replication.mongo': 'MongoDB',
  'pages.settings.replication.wholeDocuments': 'Replicate updates as whole documents',
  'pages.settings.replication.wholeDocumentsNote':
    'Off, an update carries the fields it changed: a one-megabyte document whose status flips costs a few bytes instead of a megabyte each way. On, every update is read back whole on the source and written whole to the target \u2014 the way this worked before, and the way back if a delta is ever wrong for a collection.',
  'pages.settings.replication.noTransaction': 'Apply batches without a transaction',
  'pages.settings.replication.noTransactionNote':
    'Gives up the atomicity of a batch: a half-applied batch and its position stop being one thing.',
  'pages.settings.replication.overridden': 'Overruled by the environment',
  'pages.settings.replication.save': 'Save',
  'pages.settings.replication.reload': 'Reload',
  'pages.settings.replication.saved': 'Saved. A task reads these when it next starts.',
  'pages.settings.replication.saveFailed': 'Not saved',
  'pages.settings.replication.loadFailed': 'Could not read the settings',
};
